import { render } from "./DanhSachNhaXe.vue?vue&type=template&id=013553fb&scoped=true"
import script from "./DanhSachNhaXe.vue?vue&type=script&lang=js"
export * from "./DanhSachNhaXe.vue?vue&type=script&lang=js"

import "./DanhSachNhaXe.vue?vue&type=style&index=0&id=013553fb&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013553fb"]])

export default __exports__